import { render, staticRenderFns } from "./detailDis.vue?vue&type=template&id=5e864fee&scoped=true&"
import script from "./detailDis.vue?vue&type=script&lang=js&"
export * from "./detailDis.vue?vue&type=script&lang=js&"
import style0 from "./detailDis.vue?vue&type=style&index=0&id=5e864fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e864fee",
  null
  
)

export default component.exports